import Desktop from "./components/Desktop";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import createPalette from "@material-ui/core/styles/createPalette";
import createTypography from "@material-ui/core/styles/createTypography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Mobile from "./components/Mobile";

function App() {
  const theme = createMuiTheme({
    typography: createTypography(createPalette({}), {
      fontFamily: `"Open Sans",  sans-serif`,
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightBold: 700,
    }),
  });

  const matches = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <MuiThemeProvider theme={theme}>
      <Router>
        <Switch>
          <Route path="/">{matches ? <Mobile /> : <Desktop />}</Route>
        </Switch>
      </Router>
    </MuiThemeProvider>
  );
}

export default App;
